import { GridItem, Flex, Box } from '@chakra-ui/react';

export function MiddleDivider({ rows }: { rows: number }) {
  return (
    <GridItem
      as={Flex}
      h="full"
      gridColumn="mid"
      gridRow={`1 / ${rows}`}
      justifyContent="center"
    >
      <Box
        w="1px"
        border="1px dashed"
        borderColor="texas.bg.600"
        _light={{ borderColor: 'gray.100' }}
      />
    </GridItem>
  );
}
